/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect } from "react";
import { closelightbox } from "../../util/Functions";
import { Grid, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const DeleteUnit = (props) => {
  useEffect(() => {}, []);

  const deleteUnit = async () => {
    await props.deleteUnit(props.contentModal.uuid);
    closelightbox();
  };

  return (
    <Dialog open={true} fullWidth>
			<ModalStyle property={String(false)}>
				<DialogTitle>
				  Borrar Grupo
					<IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
				</DialogTitle>
				
				<DialogContent>
					<Grid container spacing={2} >
						<Grid item xs={12} style={{fontWeight: "bolder"}}>
						  ¿Confirma que desea borrar el grupo? 
						</Grid>	
						<Grid item xs={12} >
							{props.contentModal.name}
							<hr/>
						</Grid>	
					</Grid>
				</DialogContent>

				<DialogActions>    
					<Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>     
					<Button variant="contained" onClick={deleteUnit.bind(this)} >Borrar grupo</Button>
				</DialogActions>
			</ModalStyle>
		</Dialog>
  );
};

export default DeleteUnit;
